var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "workspace-selection-header",
      attrs: { "justify-space-between": "", "align-center": "" }
    },
    [
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "", color: "primary", "open-delay": "100" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                return [
                  _c(
                    "WeezieLogo",
                    _vm._g(
                      {
                        staticClass: "back-button",
                        on: {
                          click: function($event) {
                            return _vm.$router.push({ name: "hub" })
                          }
                        }
                      },
                      on
                    )
                  )
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c("span", { staticStyle: { "font-size": "9px" } }, [
            _vm._v(_vm._s(_vm.$t("BackToHub")))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "user-button-container" },
        [
          _c("user-avatar", { on: { toggleUser: _vm.toggleUserWindow } }),
          _vm._v(" "),
          _vm.userWindowOpen
            ? _c("user-window", { attrs: { right: "10px", top: "40px" } })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("activate-two-authentication-dialog", {
        attrs: { open: _vm.opened2FArequired },
        on: {
          close: function($event) {
            _vm.opened2FArequired = false
          },
          activateAuthenticate: function($event) {
            _vm.twoFactorAuthentication = true
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bd72df44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd72df44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Workspaces/Header.vue
// module id = null
// module chunks = 